import React, { useState } from "react";
import { Link } from "react-router-dom";
import { accSoftwareTab } from "../../locales/en";
import { useSelector } from "react-redux";
import AccountingSoftwareList from "./accounting-software/AccountingSoftwareList";
import { DISCONNECTED } from "../../utils/constants/appConstants";
import AccountingSoftConnectedModal from "../../components/modals/AccountingSoftConnectedModal";

const DisconnectedSoftware = () => {
  const { disconnectConnectedSoftwareData } = useSelector(
    (state) => state.login
  );
  const [connectedSoftwareModal, setConnectedSoftwareModal] = useState(false);
  const handleConnectedSoftwareToggle = () => {
    setConnectedSoftwareModal(!connectedSoftwareModal);
  };
  const { connectionStatus, softwareName } =
    disconnectConnectedSoftwareData || {};

  return (
    <>
      <div className="accounting-software">
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <div className="row justify-content-center g-2">
              {connectionStatus === DISCONNECTED && (
                <AccountingSoftwareList softwareName={softwareName} />
              )}
              <div className="link-btn text-center">
                <Link
                  to="#"
                  className="btn btn-primary"
                  onClick={handleConnectedSoftwareToggle}
                >
                  {accSoftwareTab.linkToAnotherSoftware}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AccountingSoftConnectedModal
        isOpen={connectedSoftwareModal}
        toggle={handleConnectedSoftwareToggle}
      />
    </>
  );
};

export default DisconnectedSoftware;
